import { connect } from 'react-redux';
import View from './RetirementAssetsChartView';
import MobileView from '../MobileRetirementAssetsChart/MobileRetirementAssetsChartView';
import {
  chartDataSelector,
  loading,
  showLoading,
  proposedPlan,
} from './RetirementAssetsChartSelector';
import { fetchData, receiveData } from './RetirementAssetsChartActions';

const mapStateToProps = (state, ownProps) => {
  return {
    chartData: chartDataSelector(state, ownProps),
    loading: loading(state, ownProps),
    showLoading: showLoading(state, ownProps),
    proposed_plan: proposedPlan(state, ownProps),
  };
};

const mapDispatchToProps = dispatch => ({
  fetchData: (fpId, clientId, showLoading = false) => {
    dispatch(fetchData(fpId, clientId, showLoading));
  },
  receiveData: (data, clientId) => {
    dispatch(receiveData(data, clientId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileRetirementAssetsChart = connect(mapStateToProps, mapDispatchToProps)(MobileView);
